import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { usePageMeta } from '@/lib/usePageMeta';

export default function FoundersListConfirmed() {
  usePageMeta({
    title: 'Welcome to The Founder’s List | Toia Wallace',
    description: 'You’re officially on The Founder’s List.',
    path: '/founders-list/confirmed',
    robots: 'noindex, follow',
  });
  const { state } = useLocation();
  const first = (state?.firstName || '').split(' ')[0];
  const result = state?.result || 'created';

  const heading =
    result === 'already_active'
      ? 'You’re already on The Founder’s List.'
      : result === 'resubscribed'
        ? 'Welcome back to The Founder’s List.'
        : 'You’re officially on The Founder’s List.';

  return (
    <div className="bg-ivory min-h-screen pt-40 pb-32" data-testid="founders-list-confirmed">
      <div className="mx-auto max-w-[720px] px-6 sm:px-10 text-center">
        <div className="eyebrow text-taupe mb-8">The Founder’s List</div>
        <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-matte">
          {heading}
        </h1>
        <div className="h-px w-14 bg-gold mx-auto my-10" aria-hidden />
        <p className="font-serif-display italic text-2xl md:text-3xl text-taupe leading-snug">
          Welcome to the inside{first ? `, ${first}` : ''}.
        </p>
        <div className="mt-8 space-y-6 text-matte/75 leading-[1.85] max-w-lg mx-auto">
          <p>
            Every Friday, you’ll receive The Founder’s Brief, a five-minute look at what I’m building, the lessons I’m
            learning, the AI I’m using, and the opportunities I’m exploring.
          </p>
          <p>Your first email is on the way.</p>
          <p className="text-matte/55 text-[13px]">
            Add <span className="text-matte/80">hello@iamtoiawallace.com</span> to your contacts so The Founder’s Brief always reaches your inbox.
          </p>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-4">
          <Link to="/companies" className="btn-primary" data-testid="fl-confirmed-explore">
            Explore My Companies
            <ArrowRight size={14} strokeWidth={1.6} />
          </Link>
          <Link to="/journal" className="btn-ghost" data-testid="fl-confirmed-journal">
            Read The Journal
            <ArrowRight size={14} strokeWidth={1.6} />
          </Link>
          <Link to="/" className="btn-ghost" data-testid="fl-confirmed-home">
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}
